// Garde « single-flight » : sérialise les appels concurrents d'une tâche async.
//
// Le filet de re-synchro (use-resync-pending) est déclenché au montage, sur
// l'événement `online` ET sur chaque `appStateChange` actif. Sans garde, deux
// `run()` quasi simultanés (ex. `online` + retour au 1er plan dans la même tick)
// ré-uploadaient la MÊME capture → double INSERT → collision PK 23505, bruit
// d'erreurs et capture coincée. Tant qu'un run est en cours, les appels
// concurrents sont IGNORÉS (pas mis en file : un seul passage suffit, le prochain
// déclencheur rejouera si besoin). Module PUR → testable sans React/Capacitor.

export type SingleFlight = (fn: () => Promise<void>) => Promise<boolean>;

/**
 * Crée une garde single-flight. L'appel retourne `true` si la tâche a été
 * exécutée, `false` si elle a été ignorée (un run était déjà en cours). Le
 * verrou est relâché même si la tâche lève (puis l'exception est propagée).
 */
export function makeSingleFlight(): SingleFlight {
  let running = false;
  return async (fn) => {
    if (running) return false;
    running = true;
    try {
      await fn();
      return true;
    } finally {
      running = false;
    }
  };
}
